import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import Home from "./components/pages/Home";
import ProductDetail from "./components/pages/ProductDetail";
import CartPage from "./components/pages/CartPage";
import Address from "./components/pages/Address";
import Summary from "./components/pages/Summary";
import Payment from "./components/pages/Payment";
import Thankyou from "./components/pages/Thankyou";
import ContinuePage from "./components/pages/ContinuePage";
import ProtectedRoute from "./components/ProtectedRoute";

const isMetaBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return ua.includes("FBAN") || ua.includes("FBAV") || ua.includes("Instagram");
};

function AppRoute() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hasSecretKey = queryParams.get("access") === "granted";

  if (hasSecretKey) {
    sessionStorage.setItem("allowSite", "true");
    return <Navigate to="/home" replace />;
  }
  const hasAccess = sessionStorage.getItem("allowSite") === "true";

  return (
    <Routes>
      <Route
        path="/"
        element={
          isMetaBrowser() ? (
            hasAccess ? <Navigate to="/home" replace /> : <ContinuePage />
          ) : (
            hasAccess ? <Navigate to="/home" replace /> : <Navigate to="/home" replace />
          )
        }
      />

      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<Home />} />
        <Route path="/ProductDetail/:id" element={<ProductDetail />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/address" element={<Address />} />
        <Route path="/order-summary" element={<Summary />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/thank-you" element={<Thankyou />} />
      </Route>

      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}

export default AppRoute;




// import React, { useState, useEffect } from "react";
// import { Route, Routes, Navigate, useLocation } from "react-router-dom";

// // Imports...
// import Home from "./components/pages/Home";
// import ProductDetail from "./components/pages/ProductDetail";
// import CartPage from "./components/pages/CartPage";
// import Address from "./components/pages/Address";
// import Summary from "./components/pages/Summary";
// import Payment from "./components/pages/Payment";
// import Thankyou from "./components/pages/Thankyou";
// import ContinuePage from "./components/pages/ContinuePage";
// import NotFound from "./components/pages/NotFound";
// import ProtectedRoute from "./components/ProtectedRoute";

// const isMetaBrowser = () => {
//   const ua = navigator.userAgent || navigator.vendor || window.opera;
//   return ua.includes("FBAN") || ua.includes("FBAV") || ua.includes("Instagram");
// };

// function AppRoute() {
//   const [securityOn, setSecurityOn] = useState(null); // Initial state null
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);

//   useEffect(() => {
//     // Public folder se config fetch karna
//     fetch("/config.json")
//       .then((res) => res.json())
//       .then((data) => setSecurityOn(data.securityEnabled))
//       .catch(() => setSecurityOn(true)); // Error pe default security on
//   }, []);

//   // Jab tak config load na ho, loading dikhayein ya blank
//   if (securityOn === null) return null;

//   const hasSecretKey = queryParams.get("access") === "granted";
//   if (hasSecretKey) {
//     localStorage.setItem("allowSite", "true");
//   }

//   const hasPressedContinue = sessionStorage.getItem("allowSite") === "true";
//   const hasAccess = localStorage.getItem("allowSite") === "true";

//   return (
//     <Routes>
//       <Route
//         path="/"
//         element={
//           !securityOn ? (
//             <Navigate to="/home" replace />
//           ) : isMetaBrowser() ? (
//             (hasAccess || hasPressedContinue) ? <Navigate to="/home" replace /> : <ContinuePage />
//           ) : (
//             hasAccess ? <Navigate to="/home" replace /> : <Navigate to="/404" replace />
//           )
//         }
//       />

//       <Route element={<ProtectedRoute securityOn={securityOn} />}>
//         <Route path="/home" element={<Home />} />
//         <Route path="/ProductDetail/:id" element={<ProductDetail />} />
//         <Route path="/cart" element={<CartPage />} />
//         <Route path="/address" element={<Address />} />
//         <Route path="/order-summary" element={<Summary />} />
//         <Route path="/payment" element={<Payment />} />
//         <Route path="/thank-you" element={<Thankyou />} />
//       </Route>

//       <Route path="/404" element={<NotFound />} />
//       <Route path="*" element={<Navigate to="/404" replace />} />
//     </Routes>
//   );
// }

// export default AppRoute;